import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { usePropostaForm } from "../context/PropostaFormContext";

interface SearchableListProps<T> {
  items: T[];
  loading?: boolean;
  emptyMessage?: string;
  renderItem: (item: T) => React.ReactNode;
  getKey: (item: T) => string | number;
}

export default function SearchableList<T>({
  items,
  loading,
  emptyMessage = "Nenhum resultado encontrado",
  renderItem,
  getKey,
}: SearchableListProps<T>) {
  const { isDark } = usePropostaForm();

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <Spin indicator={<LoadingOutlined spin />} />
      </div>
    );
  }

  if (!items.length) {
    return (
      <p
        className={`text-sm py-4 text-center ${
          isDark ? "text-gray-400" : "text-gray-500"
        }`}
      >
        {emptyMessage}
      </p>
    );
  }

  return (
    <ul
      className={`proposta-searchable-list w-full min-w-0 max-w-full border rounded-lg divide-y overflow-x-hidden ${
        isDark
          ? "border-gray-700 divide-gray-700 bg-[#24304a]"
          : "border-gray-200 divide-gray-100 bg-white"
      }`}
    >
      {items.map((item) => (
        <li key={getKey(item)} className="min-w-0 max-w-full">
          {renderItem(item)}
        </li>
      ))}
    </ul>
  );
}
